import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import GetInvolved from "./pages/GetInvolved";
import Contact from "./pages/Contact";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App grain">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/get-involved" element={<GetInvolved />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
            <Toaster
                theme="light"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#F2EEE6",
                        border: "1px solid #C9C3B4",
                        color: "#1A1A1A",
                        fontFamily: "Space Mono, monospace",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
